import React from "react";

export default function Banner({ children, className = "", altBG }) {
  const backgroundImage = altBG
    ? `url(${altBG})`
    : `url(/img/bg-sunny-gradient2.webp)`;

  return (
    <section
      className={`bg-gradient-sunny bg-cover-image bg-rounded ${className}`}
      style={{ backgroundImage }}
    >
      <div className="container">
        <div className="row align-items-center justify-content-between">
          {children}
        </div>
      </div>
    </section>
  );
}
